export default "__VITE_ASSET__cd47da04__"